module.exports = __webpack_public_path__ + "media/packs/images/flags/CY-a096b2a10c17d032c0f6003fd4884e54.png";